import { formRules } from "../../../../../config/validations/formRules";
import { validations } from "../../../../../config/validations/validations";

export const rules: any = {
  name: (min?: number, max?: number, field?: string) => [
    validations.required.text(field),
    validations.min.text(1, field),
    validations.max.text(50, field),
  ],
};
